import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import {
    IconButton, TableRow, Tooltip
} from '@material-ui/core';
import { Room as GoToIcon } from '@material-ui/icons';

import { formatConstraintValue } from '../../../../../helpers/ValueFormatter';
import KeySwatch from '../../../../CartoLib/Widgets/KeySwatch';
import TableCell from '../TableCell';

class LayerTableRow extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        layerSystemName: PropTypes.string.isRequired,
        layerName: PropTypes.string.isRequired,
        name: PropTypes.string,
        type: PropTypes.string,
        value: PropTypes.number,
        bounds: PropTypes.object,
        styling: PropTypes.object,
        onShowOnMap: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.handleShowOnMap = this.handleShowOnMap.bind(this);
    }

    handleShowOnMap () {
        const { layerSystemName, bounds, onShowOnMap } = this.props;
        onShowOnMap && onShowOnMap(layerSystemName, bounds);
    }

    render () {
        const { classes, layerName, name, type, value, styling } = this.props;
        return (
            <TableRow>
                <Tooltip arrow title={layerName} placement="bottom">
                    <TableCell className={classes.tableCellRoot}>
                        <KeySwatch className={classes.layerIcon} styling={styling} />
                        {layerName}
                    </TableCell>
                </Tooltip>
                {
                    name ?
                        <Tooltip arrow title={name} placement="bottom">
                            <TableCell className={classes.tableCellRoot}>
                                {name}
                            </TableCell>
                        </Tooltip> :
                        <TableCell className={classes.tableCellRoot} />
                }
                <TableCell className={classes.tableCellRoot}>
                    {(value === 0 ? formatConstraintValue(type, 0) : (value === null ? 'N/A' : formatConstraintValue(type, value)))}
                </TableCell>
                <TableCell className={classes.tableCellRoot}>
                    <Tooltip arrow title="Show on map" placement="right">
                        <IconButton
                            className={classes.showOnMapButton}
                            onClick={this.handleShowOnMap}
                        >
                            <GoToIcon className={classes.icon} />
                        </IconButton>
                    </Tooltip>
                </TableCell>
            </TableRow>
        );
    }
}

const style = theme => ({
    tableCellRoot: {
        '&:nth-child(1)': {
            width: '40%',
            maxWidth: '0'
        },
        '&:nth-child(2)': {
            width: '40%',
            maxWidth: '0'
        },
        '&:last-child': {
            width: theme.constants.tableRowHeight,
            maxWidth: theme.constants.tableRowHeight,
            paddingRight: '0px'
        }
    },
    layerIcon: {
        display: 'inline-block',
        width: '10px',
        height: '10px',
        marginRight: theme.constants.horizontalMargin
        // background: 'red'
    },
    showOnMapButton: {
        ...theme.typography.caption,
        color: theme.palette.primary.light,
        textTransform: 'initial',
        padding: `${(theme.constants.tableRowHeight - 14) * 0.5}px`,
        fontSize: '1em'
    },
    icon: {
        fontSize: '1em',
        color: theme.palette.icon.main
    }
});

export default withStyles(style)(LayerTableRow);